module.exports = __webpack_public_path__ + "static/media/plus_fade.2122d67a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/plus_fade.png
 ** module id = 110
 ** module chunks = 0
 **/